import { CourseId } from './courses';
import { PopupNotificationId } from './popupNotifications';
import { ISODateTime } from '../../commonv3/types/dates';

export type Notification =
    | CourseCompletionNotification
    | PracticalSectionResultNotification
    | CareerChangeNotification
    | UserTutorialNotification;

export type CourseCompletionNotificationId = number;

export enum NotificationType {
    COURSE_COMPLETION = 'Online::CourseCompletionNotification',
    PRACTICAL_EXAM_RESULT = 'Online::PracticalSectionResultNotification',
    CAREER_CHANGE_SURVEY = 'career_change_notification',
    USER_TUTORIAL_COMPLETION = 'user_tutorial_completion',
}

export type CourseCompletionNotification = {
    id: CourseCompletionNotificationId;
    type: NotificationType.COURSE_COMPLETION;
    certificate_image: string;
    course_id: CourseId;
    course_title: string;
};

export type UserTutorialNotification = {
    id: PopupNotificationId;
    type: NotificationType.USER_TUTORIAL_COMPLETION;
    confirmed_at: ISODateTime;
};

export type PracticalSectionResultNotificationId = number;

export type PracticalSectionResultNotification = {
    id: PracticalSectionResultNotificationId;
    type: NotificationType.PRACTICAL_EXAM_RESULT;
    course_title: string;
    section_title: string;
    submission_code: string;
    score: number;
};

export type CareerChangeNotification = {
    type: NotificationType.CAREER_CHANGE_SURVEY;
};
